import { ParsedUrlQuery } from 'querystring'
import {
  getAccountAggregatorUrl,
  getGlobalSearchServiceUrl,
  getIndMoneyCoreAPI,
} from './api/url-constants'

export const CDN_DOMAIN = 'https://indcdn.indmoney.com'

export const TICK_ICON = `${CDN_DOMAIN}/indcdn/tick.png`

export const GREEN_TICK_ICON = `${CDN_DOMAIN}/cdnimages/fe/green_tick_1.png`
export const PENDING_ICON = `${CDN_DOMAIN}/cdn/images/fe/pending_icon.png`
export const NOT_ANNOUNCED = 'Not Announced Yet'
export const CALENDAR_ICON = `${CDN_DOMAIN}/public/images/calender-icon.png`
export const DOMAIN = 'https://www.indmoney.com'
export const EXTERNAL_LINK_ICON = `${CDN_DOMAIN}/cdnimages/fe/link_icon.png`
export const EYE_OFF_ICON = `${CDN_DOMAIN}/public/images/eye-off_masthead.png`
export const EYE_ENABLED_ICON = `${CDN_DOMAIN}/public/images/eye_enabled_masthead.png`
export const API_DOMAIN = getIndMoneyCoreAPI()
export const INV_API_DOMAIN = 'https://apixt-iw.indmoney.com/ind-investment/api'
export const PROFILEX_API_DOMAIN =
  'https://apixt-iw.indmoney.com/profilex-public/api'
export const DEV_API_DOMAIN = 'https://dev-lending-eagle.indiawealth.in/api'
export const TWO_SIDED_PUBLIC_DOMAIN =
  'https://apixt-iw.indmoney.com/two-sided/two-sided/public/api'
export const AUTO_DEV_PROD_API_DOMAIN =
  // eslint-disable-next-line no-negated-condition
  process.env.NODE_ENV !== 'production' ? DEV_API_DOMAIN : API_DOMAIN
export const US_STOCKS_FAQ_URL = `${CDN_DOMAIN}/public/us_stocks_landing.json`

export const APP_STORE_URL =
  'https://itunes.apple.com/in/app/indwealth/id1450178837?mt=8'
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=in.indwealth'

export const ARTICLES_DOWNLOAD_APP_ONE_LINK =
  'https://indmoney.onelink.me/MgHh/12ac9803'
export const DOWNLOAD_APP_ONE_LINK = 'https://indmoney.onelink.me/MgHh/e219b96f'

// sticky value proposition 750 us stocks details page
export const usStocksDetailsStickyHeaderValuePropositionOneLink =
  'https://indmoney.onelink.me/MgHh/4f00e7a4'

export const US_STOCKS_BRAND_CAMPAIGN_ONE_LINK =
  'https://indmoney.onelink.me/MgHh/d6041b54'

export const REWARDS_ALLIANCE_ONE_LINK =
  'https://indmoney.onelink.me/Fq1e/hjc1k7ho'

export const ANDROID_ONE_APP_LINK = 'https://indmoney.onelink.me/MgHh/hjjj7z41'
export const IOS_ONE_APP_LINK = 'https://indmoney.onelink.me/MgHh/hjjj7z41'

export const IOS_ONE_APP_LINK_INDSTOCKS =
  'https://indmoney.onelink.me/MgHh/i6daogy4'

export const baseURL = DEV_API_DOMAIN

export const limitPerAPICallUSStocksListing = 20

export const USER_API_URL = `${INV_API_DOMAIN}/v4/user/basic/`
export const USER_PROFILE_URL = `${PROFILEX_API_DOMAIN}/v3/userprofile/profile/`
export const USER_POC_URL = `${API_DOMAIN}/v1/user/poc/`

export const TRILLION = 1000000000000
export const BILLION = 1000000000
export const MILLION = 1000000
export const LAKH = 100000
export const THOUSAND = 1000

export const allUSStocksCategories = [
  { text: ' All', key: 'all', emoji: '🌎', emojiName: 'earth' },
  {
    text: ' Top Tech',
    key: 'top-tech-stocks',
    emoji: '💻',
    emojiName: 'laptop',
  },
  { text: ' Top ETF’s', key: 'top-etfs', emoji: '🍕', emojiName: 'pizza' },
  {
    text: ' Top Pharma',
    key: 'us-pharma-companies',
    emoji: '💊',
    emojiName: 'earth',
  },
  { text: ' Top Energy', key: 'top-energy', emoji: '🔋', emojiName: 'battery' },
  { text: ' Hot Stocks', key: 'hot-stocks', emoji: '🔥', emojiName: 'fire' },
  {
    text: ' Top Gainers',
    key: 'top-gainers',
    emoji: '📈',
    emojiName: 'chart going up',
  },
  {
    text: 'Financial Stocks',
    key: 'fin-stocks',
    emoji: '💹',
    emojiName: 'chart going down',
  },
  {
    text: 'FAANG',
    key: 'faang',
    emoji: '✨',
    emojiName: 'chart going down',
  },
  // { text: '🏛️ Bonds', key: 'bonds' },
  // { text: '📈 Finance', key: 'finance' },
  // { text: '🏭 Industrials', key: 'industrials' },
  // { text: '🔍 Explore All', key: 'explore-all' },
] as const

export type USStocksCategoryTypes =
  (typeof allUSStocksCategories)[number]['key']

export const DOLLAR_SYMBOL = '$'
export const PERCENTAGE_SYMBOL = '%'
export const RUPEE_SYMBOL = '₹'
export const LAKH_UNIT = 'L'
export const THOUSAND_UNIT = 'K'
export const secondsInOneDay = 24 * 60 * 60
export const secondsInOneHour = 60 * 60
export const CLOSE_SYMBOL = '✕'

export const usStocksPageLink = '/us-stocks'
export const goalsPageLink = '/goals'
export const investmentsPageLink = '/investments/overview'
export const dashboardPageLink = '/dashboard'
export const taxPageLink = '/tax'
export const mutualFundsPageLink = '/mutual-funds'
export const indianStocksPageLink = '/stocks'
export const primeMembershipPageLink = '/profile/my-membership'
export const calculatorPageLink = '/calculators'
export const ipoCenterPageLink = '/ipo'
export const advisoryUnitPageLink = 'page/advisoryunit'
export const insurancePageLink = '/insurance'
export const instaCashPageLink = 'page/insta-cash'
export const loginPageLink = '/login'
export const plansWithoutAdvisors = ['PRIME_99']
export const creditScorePageLink = '/check-free-credit-score'
export const DEFAULT_ARTICLES_FETCH_LIMIT = 12

export const OTP_FLOW_TYPE = {
  MF_TXN_2FA: 'MF_TXN_2FA',
  KYC_EMAIL_VERIFY: 'KYC_EMAIL_VERIFY',
  MF_CENTRAL_TRACKING: 'MF_CENTRAL_TRACKING',
  OTP_SERVICE_FLOW: 'OTP_SERVICE_FLOW',
  US_STOCKS_DEPOSIT_AUTH_OTP: 'US_STOCKS_DEPOSIT_AUTH_OTP',
}

export const ARTICLES_SIDEBAR_APP_DOWNLOAD_ONE_LINK =
  'https://indmoney.onelink.me/MgHh/hflojfl9'
export const ARTICLES_SIDEBAR_AGILIS_APP_DOWNLOAD_ONE_LINK =
  'https://indmoney.onelink.me/MgHh/nmiru4em'

// ACCOUNT AGGREGATOR API URLs
export const getFinvuUserDetailsAPIUrl = (IFSC: string) =>
  `${getAccountAggregatorUrl()}/api/v1/aggregator/initiate-consent/?bank_ifsc=${IFSC}`

export const getFinvuNavlinkRedirectUrl = (
  queryObj: ParsedUrlQuery,
  consentStatus: 'ACCEPT' | 'DENY',
) => {
  const fipId = queryObj.fipId ?? ''
  const source = queryObj.source ?? ''
  const basket_id = queryObj.basket_id ?? ''
  const status_id = queryObj.status_id ?? ''
  const platform = queryObj.platform ?? ''
  const flow_type = queryObj.flow_type ?? ''
  const url = `${getAccountAggregatorUrl()}/api/v1/aggregator/linking-navlink?fipId=${fipId}&source=${source}&consent_status=${consentStatus}&basket_id=${basket_id}&status_id=${status_id}&native_platform=${platform}&flow_type=${flow_type}`
  return url
}

export const postFinvuDenyFeedbackUrl = `${getAccountAggregatorUrl()}/api/v1/aggregator/denied-consent-reason`

export const SITE_KEY = '6LfZZMQbAAAAAHOAGRd_xYy8YwYDC9nxf0V8LwuC'
export const V2_SITE_KEY = '6Lfc_eAqAAAAAL2cPTkdmjGdfvJTWHoRWcPHrymS'

export const IND_STOCKS_SCREENER_BASE_URL =
  process.env.STAGING_ENV === 'production'
    ? `${getGlobalSearchServiceUrl()}/v1`
    : 'https://global-search-pp.indiawealth.in/public/v1'

export const getPlatformType = (isMobile?: boolean) => {
  return isMobile ? 'mweb' : 'dweb'
}

export const Months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const TimeFrame = {
  ONE_MINUTE: 60 * 1000,
  FIVE_MINUTES: 5 * 60 * 1000,
  FIFTEEN_MINUTES: 15 * 60 * 1000,
  HALF_HOUR: 30 * 60 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
  TWENTY_FOUR_HOUR: 24 * 60 * 60 * 1000,
}

export const MOBILE_BREAKPOINT = 768

export const isMobileDevice = () => {
  return typeof window === 'object' && window.innerWidth <= MOBILE_BREAKPOINT
}

export const allowedDoFollowDomains = [
  'indmoney.com',
  'onelink.me',
  'indstocks.com',
  'googletagmanager.com',
  'youtube.com',
  'apple.com',
  't.me',
  'facebook.com',
  'instagram.com',
  'threads.net',
]

export const REFRESH_TOKEN_CONST = {
  API_TYPE: 'REFRESH_TOKEN',
  REFRESH_TOKEN_BAD_REQUEST: 'refresh_token_bad_request',
  REFRESH_TOKEN_ERROR: 'refresh_token_error',
  REFRESH_TOKEN_NOT_PRESENT: 'refresh_token_not_present',
  REFRESH_TOKEN_UNAUTHOTIZED: 'refresh_token_unauthorized',
}
